import { useState } from "react";
import { motion } from "framer-motion";

export const ServiceGallery = ({ images, number, testId }) => {
  const [active, setActive] = useState(0);
  const cur = images[active];
  return (
    <div data-testid={`service-gallery-${testId}`} className="space-y-3">
      <figure className="relative m-0 overflow-hidden rounded-2xl border border-white/10 bg-void">
        <div className="relative flex aspect-[16/10] items-center justify-center overflow-hidden">
          <img
            src={cur.src}
            aria-hidden="true"
            className="absolute inset-0 h-full w-full scale-110 object-cover opacity-30 blur-2xl"
          />
          <motion.img
            key={cur.src}
            initial={{ opacity: 0.2, scale: 1.01 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
            src={cur.src}
            alt={cur.label}
            loading="lazy"
            decoding="async"
            className="relative h-full w-full object-contain"
          />
        </div>
        {number && (
          <span className="absolute left-5 top-5 font-mono text-sm uppercase tracking-[0.2em] text-amber">{number}</span>
        )}
        <figcaption
          data-testid={`service-caption-${testId}`}
          className="border-t border-white/10 bg-obsidian px-5 py-3 font-mono text-[11px] uppercase tracking-[0.15em] text-white/55"
        >
          {cur.label}
        </figcaption>
      </figure>

      <div className="grid grid-cols-2 gap-3">
        {images.map((im, i) => (
          <button
            key={im.src}
            type="button"
            onClick={() => setActive(i)}
            data-testid={`gallery-thumb-${testId}-${i}`}
            aria-label={`Show ${im.label}`}
            aria-pressed={i === active}
            className={`group relative overflow-hidden rounded-xl border transition-colors ${
              i === active ? "border-amber" : "border-white/10 hover:border-white/30"
            }`}
          >
            <div className="flex aspect-[16/10] items-center justify-center bg-void">
              <img
                src={im.src}
                alt={im.label}
                loading="lazy"
                className={`h-full w-full object-contain transition-opacity ${i === active ? "opacity-100" : "opacity-70 group-hover:opacity-100"}`}
              />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
